import { FaArrowRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'

const BlogCard = ({ blog }) => {

  const navigate = useNavigate()

  // console.log(blog)

  const handleNavigate = (blogId) => {
    navigate(`blog-details/${blogId}`)
    window.scrollTo(0, 0)
  }

  return (
    <div data-aos="zoom-in-up" className="lg:h-[430px] md:h-[740px] h-[430px] w-full rounded-3xl overflow-hidden shadow-lg bg-white relative">
      <div className={`bg-gradient-to-r xl:h-[220px] lg:h-[cald((calc(430px-30%)%430px)*100)] md:h-[calc((518px))] h-[200px] flex items-center justify-center text-white w-full absolute top-0`}>
        <img data-aos={"zoom-in"} data-aos-duration="700" src={blog.image} alt="img" className="h-full w-full object-cover object-center" />
      </div>
      <div className='w-[100] md:py-12 md:px-10 py-8 px-5 flex flex-col divide-y gap-y-5 rounded-tl-3xl rounded-tr-3xl xl:h-[calc(430px-40%)] lg:h-[calc(430px-30%)] md:h-[250px] h-[calc(430px-35%)] bg-white absolute bottom-0 inset-x-0'>
        <div data-aos="fade-up" data-aos-duration="700" className="uppercase text-sm flex flex-col sm:flex-row lg:flex-col xl:flex-row items-center lg:justify-between justify-center gap-5 font-medium">
          {
            blog.label.slice(0, 2).map(({ image, text }, index) => (
              <h1 key={index} className="flex items-center gap-1 hover:text-[#0BB6D9] transition-all duration-500 cursor-pointer"><img className='h-4 w-4' src={image} alt="tag-image" /> {text}</h1>
            ))
          }
        </div>
        <div onClick={() => handleNavigate(blog._id)} className="pt-5 flex flex-col items-center gap-y-5 text-sm familjen-font">
          <h1 data-aos="fade-up" data-aos-duration="700" className="text-ellipsis line-clamp-2 font-semibold text-2xl text-center hover:text-[#0BB6D9] transition-all duration-500 cursor-pointer">{blog.title}</h1>
          <button data-aos="fade-up" data-aos-duration="700" className="uppercase flex items-center overflow-hidden group"><div className="flex font-bold items-center gap-2 duration-500 ease-in-out transition-transform whitespace-nowrap -translate-x-4 group-hover:translate-x-4"><span className="opacity-0 group-hover:opacity-100 transition-all duration-300"><FaArrowRight /></span><span className="group-hover:text-[#0BB6D9] transition-all duration-500">read more</span><span className="opacity-100 group-hover:opacity-0 transition-all duration-300"><FaArrowRight /></span></div></button>
        </div>
      </div>
    </div>
  )
}

export default BlogCard